<template>
  <div id="app">
    <nav-bar />
    <aside-menu :menu="menu" />
    <router-view />
    <footer-bar />
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from '@/components/NavBar'
import AsideMenu from '@/components/AsideMenu'
import FooterBar from '@/components/FooterBar'

export default {
  name: 'Home',
  components: {
    FooterBar,
    AsideMenu,
    NavBar
  },
  computed: {
    menu () {
      return [
        'General',
        [
          {
            to: '/',
            icon: 'desktop-mac',
            label: 'Dashboard'
          }
        ],
        'Data Feeds',
        [
          {
            to: '/feed/new',
            label: 'Create new...',
            icon: 'plus'
          //  updateMark: true
          },
          {
            to: '/feed/43',
            label: 'MyBase data1',
            icon: 'table',
            updateMark: true

          }
        ],
        'Account',
        [
          {
            href: '/key',
            label: 'Airtable Key',
            icon: 'key'
          },
          {
            href: '/upgrade',
            label: 'Billing',
            icon: 'credit-card'
          },
          {
            href: 'https://AirJson.com/bulma-admin-template/one',
            label: 'Help',
            icon: 'help-circle'
          }
        ]
      ]
    }
  },
  created () {
    this.$store.commit('user', {
      name: 'John Doe',
      email: 'john@example.com',
      avatar: 'https://avatars.dicebear.com/v2/gridy/John-Doe.svg'
    })
  }
}
</script>
